export default function FolderOpenIcon() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M2.5 8.5V5.3A2.3 2.3 0 0 1 4.8 3h2.1l2.4 1.7h6a2.2 2.2 0 0 1 2.2 2.2v1.6"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2 9h16l-2 7H4L2 9Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
